import './CmsWorkyAppCard.css';

type CmsWorkyAppCardProps = { heading: string; text: string };
export const CmsWorkyAppCard = ({ heading, text }: CmsWorkyAppCardProps): JSX.Element => {
	return (
		<div id="worky-app-card">
			<div className="not-mobile">
				<div className="image-wrapper">
					<div className="image">
						<div className="content-wrapper">
							<h1>Worky App</h1>
							<p>Alla kontorstjänster utan bindningstid för er verksamhet.</p>
							<ButtonLinks />
						</div>
					</div>
				</div>
			</div>

			<div className="only-mobile">
				<div className="image-wrapper">
					<div className="image"></div>
				</div>
				<h1>{heading}</h1>
				<p>{text}</p>
				<ButtonLinks />
			</div>
		</div>
	);
};

const ButtonLinks = (): JSX.Element => {
	const desktopAppleLogo = (
		<img src="/images/apple-store-logo-white.png" alt="apple store icon" className="not-mobile" />
	);
	const mobileAppleLogo = <img src="/images/apple-store-logo.png" alt="apple store icon" className="only-mobile" />;
	return (
		<div className="button-links">
			<a href="https://apps.apple.com/in/app/worky/id6446092958" className="button" target="_blank">
				<p>Apple Store</p>
				{desktopAppleLogo}
				{mobileAppleLogo}
			</a>
			<a
				href="https://play.google.com/store/apps/details?id=com.workygroup.customerapp"
				className="button"
				target="_blank"
			>
				<p>Play Store</p>
				<img src="/images/play-store-logo.png" alt="play store icon" />
			</a>
		</div>
	);
};
